import axios from "axios";
import { api } from "../../app/conf";
import { VERSION } from "../repository/types";
import { attachResponseInterceptor } from "./interceptors";

const axiosInstance = axios.create({
  baseURL: `${api}${VERSION.VERSION_1}`,
});

attachResponseInterceptor(axiosInstance);

export default axiosInstance;
